import { render, staticRenderFns } from "./buildGeneration.vue?vue&type=template&id=616de35c&scoped=true"
import script from "./buildGeneration.vue?vue&type=script&lang=js"
export * from "./buildGeneration.vue?vue&type=script&lang=js"
import style0 from "./buildGeneration.vue?vue&type=style&index=0&id=616de35c&prod&lang=css"
import style1 from "./buildGeneration.vue?vue&type=style&index=1&id=616de35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616de35c",
  null
  
)

export default component.exports